import { PageProps } from 'gatsby';
import React from 'react';
import Base from './Base';

/**
 * This layout component wraps all rendered pages and stays mounted when
 * navigating.
 * */
const Layout: React.FC<PageProps<null, { layout?: string }>> = ({
  children,
}) => <Base>{children}</Base>;

export default Layout;
